import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { strip } from '../common/utils';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { entityIdentRowActions } from '../../store/entityIdentRowStore';
import { lastSubjectActions } from '../../store/lastSubjectsStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import MainHeader from './mainHeader';

import '../common/mergeHeader.scss';
import { GRAPH_MODE } from '../../store/charts/common/constants';

class MergeHeader extends React.Component {

    componentDidMount() {
        this.props.ensureEntityInfo(this.getFirstEntityId());
        this.pushSubject();
    }

    componentDidUpdate() {
        this.pushSubject();
    }

    pushSubject = () => {
        const entityId = this.getFirstEntityId();
        const entityInfo = this.props.entityInfos[entityId] && this.props.entityInfos[entityId].result;
        if (isNullOrUndefined(entityInfo))
            return null;

        this.props.pushSubject(entityInfo);
    }

    getFirstEntityId = () => {
        return window.location.pathname.match(/\d+/)[0];
    }

    getEntitiesIds = () => {
        const idsParam = this.props.match.params.id;
        return idsParam.split(',').map(x => parseInt(x));
    }

    isPath = () => {
        return this.props.charts.mode === GRAPH_MODE.path || window.location.search.indexOf('mode=path') !== -1;
    }

    nodesCountDiff = () => {
        return this.isPath() ? 0 : -1;
    }

    render() {
        return (<>
            <MainHeader label={this.isPath() ? 'Search.Relations' : 'Search.Clipboard.MergeOfSubjects'} {...this.props} charts />
            {!this.props.isMobile && this.renderSubHeader()}
        </>)
    }

    renderSubHeader = () => {
        const entityId = this.getFirstEntityId();
        const entityInfo = !isNullOrUndefined(this.props.entityInfos[entityId]) ? this.props.entityInfos[entityId].result : null;

        if (isNullOrUndefined(entityInfo))
            return null;

        return (
            <>
                <div className={classnames('tabs tabs-subheader shadowed', { 'tinted': this.isTinted() })}>
                    <div className={classnames('merge-header-title', { 'tinted': this.isTinted() })}>
                        <div style={{ display: 'flex' }}>
                            {this.renderEntityData(entityInfo)}
                        </div>
                        <div>
                            {this.props.charts.nodeCount !== 0 && <span className="text-nowrap" style={{ marginLeft: '1em', fontWeight: '600' }} id="lblChartNodesCount"><Translate id='Charts.NumberOfNodes' /> {this.props.charts.nodeCount + this.nodesCountDiff()}</span>}
                        </div>
                    </div>
                </div>
                {
                    this.props.report.isLoading &&
                    <div className="search-report-progress-wrapper">
                        <div className="search-progress searching"></div>
                    </div>
                }
            </>
        );
    }

    renderEntityData = (entityInfo) => {
        const numberOfEntities = this.isPath() ? 2 : this.getEntitiesIds().length;

        return (
            <React.Fragment>
                <div className='bold-text'>{strip(entityInfo.queryName)}</div>
                <div className='merge-header-separator'>|</div>
                {this.renderSubjectId(entityInfo)}
                {(numberOfEntities > 1) && <div className='merge-header-separator'><span>{this.renderAndNMoreSubjectsTranslate(numberOfEntities - 1)}</span></div>}
            </React.Fragment>
        )
    }

    renderSubjectId = (entityInfo) => {
        return <div>
            {entityInfo.type === 2 ? <>
                {entityInfo.dateOfBirth && <>
                    <span><Translate id="Report.NaturalIdentData.DateOfBirth" />:&nbsp;</span>
                    <span className={entityInfo.entrepreneur ? "qs-result-id-entrepreneur" : null}>{entityInfo.dateOfBirthFormated}</span>
                </>}
            </> : <>
                {entityInfo.ico && <>
                    <span><Translate id="Report.CompanyIdentification.Ico" />:&nbsp;</span>
                    <span className={entityInfo.entrepreneur ? "qs-result-id-entrepreneur" : null}>{ReactHtmlParser(entityInfo.ico)}</span>
                </>}
            </>}
        </div>
    }

    renderAndNMoreSubjectsTranslate(number) {
        switch (number) {
            case 1:
                return <Translate id="Search.Clipboard.Merge.And1MoreSubject" />
            case 2:
            case 3:
            case 4:
                return <Translate id="Search.Clipboard.Merge.And2MoreSubjects" data={{ 0: number }} />
            default:
                return <Translate id="Search.Clipboard.Merge.AndNMoreSubjects" data={{ 0: number }} />
        }
    }

    isTinted = () => {
        try {
            return localStorage.locales_tint === 'header';
        } catch {
            return false;
        }
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state.entityIdentRow, report: state.report, charts: state.charts }),
    dispatch => bindActionCreators({ ...entityIdentRowActions, ...lastSubjectActions }, dispatch)
)(MergeHeader)));